// ====================================================================================
// swiper2.module
// ====================================================================================
import Swiper from "swiper";
import { Pagination, Navigation, A11y, Keyboard } from "swiper/modules"; // Pagination, Scrollbar

export const init = function () {
  const swiperContainers = document.querySelectorAll(".swiper-container--2");

  swiperContainers.forEach(function (slider) {
    let cID = slider.getAttribute("id");
    let sID = slider.querySelector(".swiper").getAttribute("id");

    let swiper = new Swiper(`#${sID}`, {
      modules: [Pagination, Navigation, Keyboard, A11y],
      loop: true,
      speed: 500,
      slidesPerView: 1,
      breakpoints: {
        390: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      pagination: {
        el: `#${cID} .swiper-pagination`,
        type: "bullets",
        clickable: true,
      },
      navigation: {
        prevEl: `#${cID} .swiper-button-prev`,
        nextEl: `#${cID} .swiper-button-next`,
      },
      keyboard: { enabled: true },
      a11y: {
        enabled: true,
        prevSlideMessage: "Vorherige Folie",
        nextSlideMessage: "Nächste Folie",
      },
      on: {
        afterInit: function (swiper) {
          slider.classList.add("slider-init");
        },
        lock: function () {
          document.querySelector(`#${cID}`).classList.add("slider-locked");
        },
        unlock: function () {
          document.querySelector(`#${cID}`).classList.remove("slider-locked");
        },
      },
    });
  });
};
